import React from "react";
import i18n from "i18n";

export default function UndoToastAction({ onUndo }) {
	return (
		<button
			type="button"
			className="rrt-undo-action"
			onClick={(event) => {
				event.preventDefault();
				event.stopPropagation();
				if (onUndo) {
					onUndo();
				}
			}}
		>
			{i18n.t("undo.action")}
		</button>
	);
}
